import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import {
    lawParagraph14aConditionsMet,
    isPluginGeneratingPlant,
    isPv,
    isRequestWithoutPlanning,
} from './common';
import Vue from 'vue';

export const generalRules = async (
    application: ApplicationForm,
): Promise<void> => {
    await Vue.nextTick();

    application.powerConnection.disabled = isPluginGeneratingPlant(application);

    application.plantBuilder.disabled =
        (!application.plantOperator.plantBuilder.disabled &&
            application.plantOperator.plantBuilder.value === 'operator') ||
        isRequestWithoutPlanning(application);

    application.propertyOwner.disabled =
        application.plantOperator.separatePropertyOwner.disabled ||
        application.plantOperator.separatePropertyOwner.value === 'no';

    application.billing.disabled =
        application.generationType.plantType.value === 'storage' ||
        application.powerConnection.doesConnectionExist.value === 'no' ||
        application.powerConnection.whichVoltageLevel.value ===
            'mediumVoltage' ||
        isRequestWithoutPlanning(application) ||
        (isPv(application) &&
            (application.plantPerformance.photovoltaic.pvOverallNominalPower
                .value ?? 0) > 100);

    application.plantData.disabled =
        isRequestWithoutPlanning(application) &&
        application.generationType.plantType.value !== 'storage';

    application.measuringConcepts.disabled = isRequestWithoutPlanning(
        application,
    );

    application.controllableConsumptionDevices.disabled = !lawParagraph14aConditionsMet(
        application,
    );
};
